export default __webpack_public_path__ + "static/hero-5c39336fff760ba54d7797441c519c70.png";